import { ReactNode, useEffect, useState } from "react";
import { Space } from "antd";
import QRCode from "qrcode.react";
import {
  QRCODE_QUERY_MAP,
  rechargeChannelsCode,
} from "project-config/constants";
import RefreshIcon from "@/assets/images/refresh.png";
import { useTranslation } from "react-i18next";
import { isDev } from "project-config/utils/env";
import Wechat from "@/assets/images/pay-wechat.png";
import Alipay from "@/assets/images/alipay.png";
import { useGlobalStore } from "@/store/GlobalStore";
import { getUserKey } from "@/utils/getUesrKey";
import { RightOutlined } from "@ant-design/icons";
import { useTimestamp } from "@/hooks/use-timestamp";
import { useUserPropertyStore } from "@/store2/userProperty/user-property-store";
import { usePictureTopUpStore } from "../../store";
import {
  Gift,
  HiddenTopLeft,
  PayType,
  PaymentContent,
  PaymentWayWrapper,
  Price,
  QRCodeContainer,
  QRCodeDisabledProtocol,
  QRCodeLoading,
  RefreshButton,
} from "./atom";

import { PaySuccessSocket } from "../pay-socket";
import { BalanceTipType, ExtraWelfareTipType } from "../../types";

export function PaymentWay({
  qrcodeLink,
  onClickCantScanCode,
  paying,
  extra,
  disabledProtocol,
  balanceTip,
  extraTip,
  desktopTip,
  style,
}: {
  qrcodeLink?: string;
  onClickCantScanCode?: () => void;
  paying?: boolean;
  extra?: ReactNode;
  disabledProtocol?: boolean;
  balanceTip?: BalanceTipType[];
  extraTip?: ExtraWelfareTipType[];
  desktopTip?: ExtraWelfareTipType[];
  style?: object;
}) {
  const { userInfo, languageFlag, currencySymbol, isCertified } =
    useGlobalStore();
  const { userProperty } = useUserPropertyStore();
  const isSubmitTask = userProperty?.isSubmitTask;
  const [localTimestamp, setLocalTimestamp] = useState(Date.now());
  const { timestamp, fetchTimestamp } = useTimestamp();
  const hasScanned = usePictureTopUpStore((state) => state.hasScanned);
  const rechargeSecondActiveName = usePictureTopUpStore(
    (state) => state.rechargeSecondActiveName
  );
  const amount = usePictureTopUpStore((state) => state.amount);
  const { setter } = usePictureTopUpStore();
  const { t } = useTranslation("topup");
  const userKey = getUserKey();
  const host = isDev()
    ? "https://task-pre.renderbus.com"
    : "https://task.renderbus.com";
  const decimal = String(amount).split(".")[1] || "";
  const wholeText = () => {
    const noCertifiedSubmit =
      !isCertified && !Boolean(isSubmitTask) ? "1" : "0";
    const paramStr = `${host}/mobile-pay?${QRCODE_QUERY_MAP.platform}=${userInfo?.platform}&${QRCODE_QUERY_MAP.timeStamp}=${timestamp}&${QRCODE_QUERY_MAP.languageFlag}=${languageFlag}&${QRCODE_QUERY_MAP.userKey}=${userKey}${qrcodeLink}&${QRCODE_QUERY_MAP.noCertifiedSubmit}=${noCertifiedSubmit}&${QRCODE_QUERY_MAP.rechargeChannels}=${rechargeChannelsCode.Web}`;
    return paramStr;
  };
  const balanceTipList = balanceTip?.filter(
    (item: any) => item.content.length > 0
  );
  const extraTipList = extraTip?.filter((item: any) => item.content.length > 0);
  const desktopTipList = desktopTip?.filter(
    (item: any) => item.content.length > 0
  );

  const isDesktopContext = desktopTipList && desktopTipList.length > 0;

  const disabledQrCode = () => {
    const belowMinAmount = isDesktopContext
      ? amount < 1
      : rechargeSecondActiveName !== "second-tab-first-recharge" && amount < 5;

    return (
      !amount ||
      Number.isNaN(amount) ||
      belowMinAmount ||
      amount > 200000 ||
      decimal.length > 2
    );
  };

  const refreshCode = () => {
    fetchTimestamp().catch(console.trace);
    setLocalTimestamp(Date.now());
    setter({ hasScanned: false });
  };

  useEffect(() => {
    if (disabledProtocol === true) {
      return;
    }
    if (!isCertified && !Boolean(isSubmitTask)) {
      const timer = setInterval(refreshCode, 10000);
      return () => clearInterval(timer);
    }
    const timer = setInterval(() => {
      if (Date.now() - localTimestamp > 1000 * 60 * 3) {
        refreshCode();
      }
    }, 1000 * 3);
    return () => {
      clearInterval(timer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [localTimestamp, isCertified, isSubmitTask, disabledProtocol]);

  useEffect(() => {
    if (disabledProtocol === false) {
      refreshCode();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disabledProtocol]);

  return (
    <PaymentWayWrapper style={style}>
      <PaySuccessSocket />
      <QRCodeContainer>
        <QRCode size={130} value={wholeText()} />
        {disabledQrCode() && <QRCodeLoading />}
        {disabledQrCode() && <HiddenTopLeft />}
        {disabledProtocol && (
          <QRCodeDisabledProtocol>
            {t("picture_protocol")}
          </QRCodeDisabledProtocol>
        )}
        {hasScanned && (
          <RefreshButton onClick={refreshCode}>
            <img src={RefreshIcon} alt="refresh" />
            <span>{t("topup_payment_refresh")}</span>
          </RefreshButton>
        )}
      </QRCodeContainer>
      <PaymentContent>
        <div>
          <Price>
            <span>{t("topup_payment_meoney")}</span>
            <span className={"unit"}>{currencySymbol}</span>
            <span className={"price"}>{Number(amount)} </span>
          </Price>
          {((balanceTipList && balanceTipList.length > 0) ||
            (extraTipList && extraTipList.length > 0) ||
            (desktopTipList && desktopTipList.length > 0)) && (
            <Space>
              {(balanceTipList && balanceTipList.length > 0) ||
              (desktopTipList && desktopTipList.length > 0) ? (
                <span>{t("activity_qing_cloud_arrive")}</span>
              ) : null}
              {balanceTipList && balanceTipList.length > 0 && (
                <Gift>
                  <span>{t("topup_balance")}</span>
                  <span className="gift-num">{balanceTipList[0].content}</span>
                </Gift>
              )}
              {extraTipList && extraTipList.length > 0 && (
                <>
                  {extraTipList.map((item, index: number) => (
                    <Gift key={index}>
                      <span>{item.pre}</span>
                      <span className="gift-num">
                        <span>{item.contentPre}</span>
                        <span>
                          {Number(
                            item.content
                              .reduce((acc, v) => acc + Number(v), 0)
                              .toFixed(2)
                          )}
                        </span>
                        <span>{item.contentSuf}</span>
                      </span>
                    </Gift>
                  ))}
                </>
              )}
              {desktopTipList && desktopTipList.length > 0 && (
                <>
                  {desktopTipList.map((item, index: number) => (
                    <Gift key={index}>
                      <span>{item.pre}</span>
                      <span className="gift-num">
                        <span>{item.contentPre}</span>
                        <span>
                          {Number(
                            item.content
                              .reduce((acc, v) => acc + Number(v), 0)
                              .toFixed(2)
                          )}
                        </span>
                      </span>
                    </Gift>
                  ))}
                </>
              )}
            </Space>
          )}
        </div>
        {extra}
        <PayType>
          <img src={Wechat} alt="" className="wechat" />
          <img src={Alipay} alt="" className="ali" />
          <span>{t("topup_payment_text")}</span>
          <button
            onClick={() => {
              onClickCantScanCode?.();
            }}
            disabled={disabledQrCode() || disabledProtocol}
            className={disabledQrCode() || disabledProtocol ? "disabled" : ""}
          >
            {paying ? "wait..." : t("recharge_cannot_scan")}
            {!paying && <RightOutlined />}
          </button>
        </PayType>
      </PaymentContent>
    </PaymentWayWrapper>
  );
}
